import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ConfigProvider } from "antd";
// import ChatPage from "./pages/ChatPage";
import SuperChatPage from "./pages/SuperChatPage";
import React from "react";
import UChatPage from "./pages/UChatPage";
import UChatPageV2 from "./pages/UChatPageV2";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#1677ff",
          borderRadius: 4,
        },
      }}
    >
      <Router>
        <Routes>
          {/* <Route path="/chat" element={<ChatPage />} /> */}
          <Route path="/super-chat" element={<SuperChatPage />} />
          <Route path="/chat" element={<UChatPage />} />
          <Route path="/uchat" element={<UChatPageV2 />} />
          <Route path="/chat-v2" element={<Navigate to="/uchat" replace />} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;
